export const site = {
  name: "黑料在线",
  tagline: "一键吃瓜，秒开速览",
  slogan: "把一整个话题，浓缩成 90 秒能读完的重点",
  intro:
    "黑料在线是一个娱乐话题速览站。我们把综艺、影视、舞台、造型、音乐里的热门讨论，整理成不用层层跳转的短篇速览，让你在碎片时间里也能直接看懂一场吃瓜的来龙去脉。",
  email: "hello@heiliaoonline.example.com",
  workingHours: "周一至周五 10:00 - 19:00",
  updateNote: "每天 09:00 / 18:00 两次更新热榜",
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "吃瓜热榜", path: "/hot" },
  { label: "专题库", path: "/topics" },
  { label: "关于我们", path: "/about" },
  { label: "联系我们", path: "/contact" },
];

export const stats = [
  { value: "12,480", label: "已整理的吃瓜话题" },
  { value: "6", label: "内容专题方向" },
  { value: "90秒", label: "单篇平均读完时长" },
  { value: "2 次/天", label: "热榜更新频率" },
];

export const principles = [
  {
    icon: "ri-filter-3-line",
    title: "只做二次归纳",
    desc: "我们梳理公开讨论的脉络与结论，不复述无来源的爆料，也不替任何人下定论。",
  },
  {
    icon: "ri-shield-check-line",
    title: "隐私优先",
    desc: "涉及私人生活与非公开信息的内容一律不收录，讨论只停留在公开的作品与舞台表现。",
  },
  {
    icon: "ri-speed-up-line",
    title: "秒开无跳转",
    desc: "重点结论写在前三行，不需要一层层点开链接，扫一眼就能知道这场话题在聊什么。",
  },
  {
    icon: "ri-emotion-happy-line",
    title: "理性吃瓜",
    desc: "把吃瓜当成一种轻松的社交谈资，而不是站队与攻击，评论区倡导好好说话。",
  },
];

export const testimonials = [
  {
    name: "小满",
    role: "通勤党",
    text: "早高峰十分钟能刷完三条速览，重点都写在前两行，不用再点开一堆链接。",
  },
  {
    name: "阿哲",
    role: "综艺爱好者",
    text: "专题分类很清楚，想看舞台就看舞台，想看造型就看造型，省事。",
  },
  {
    name: "Nora",
    role: "内容运营",
    text: "热榜榜单是我每天找选题的第一站，热度标注很有参考价值。",
  },
];